import {Colors} from '@adsk/bim360-matrix-react-helpers/es/consts';
import {ENV_CONFIGS} from '../constants/envs';

export const hasChecklistLinked = issue => issue.links.length && issue.links[0]?.type === 'checklist';
export const getChecklistUrn = issue => (hasChecklistLinked(issue) ? issue.links[0].data?.urn3 : null);

export const getChecklistInstance = (checklistCollection, instanceUrn, sectionUrn, itemUrn) => {
  if (
    checklistCollection.instances[instanceUrn] &&
    checklistCollection.sections[sectionUrn] &&
    checklistCollection.items[itemUrn]
  ) {
    return {
      instance: checklistCollection.instances[instanceUrn],
      section: checklistCollection.sections[sectionUrn],
      item: checklistCollection.items[itemUrn]
    };
  }
  return null;
};

export const getChecklistDetailHelper = (issue, checklistCollection) => {
  if (issue.attributes.links.length === 0) {
    return null;
  }
  const {urn1: itemUrn, urn2: sectionUrn, urn3: instanceUrn} = issue.attributes.links[0]?.data ?? {};
  // NGF-4583 - itemUrn and sectionUrn values are swapped and stored incorrectly in DB
  // check store with both possibilities : [itemUrn, sectionUrn] = [sectionUrn, itemUrn]
  return (
    getChecklistInstance(checklistCollection, instanceUrn, sectionUrn, itemUrn) ??
    getChecklistInstance(checklistCollection, instanceUrn, itemUrn, sectionUrn)
  );
};

export const mapDataToClientSide = ({data: response}) => {
  const instances = response.data.reduce((result, instance) => {
    result[instance.attributes.urn] = {...instance.attributes, id: instance.id};
    return result;
  }, {});
  const sections = {};
  const items = {};
  response.included.forEach(value => {
    if (value.type === 'instance_sections') {
      sections[value.attributes.urn] = value.attributes;
    } else {
      items[value.attributes.urn] = value.attributes;
    }
  });
  return {instances, sections, items};
};

export const Statuses = {
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed'
};

export const statusColorMapping = {
  [Statuses.NOT_STARTED]: Colors.GRAY_DARK,
  [Statuses.IN_PROGRESS]: Colors.YELLOW,
  [Statuses.COMPLETED]: Colors.BLUE
};

export const getDeeplinkUrl = ({id}, {number}, projectId) =>
  `${ENV_CONFIGS.CHECKLIST_FE}/projects/${projectId}/checklists/${id}#section=${number}`;
